import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e871ed54&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e871ed54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e871ed54')) {
      api.createRecord('e871ed54', component.options)
    } else {
      api.reload('e871ed54', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e871ed54&scoped=true", function () {
      api.rerender('e871ed54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/protocolCompliance/protocolUpdate/index.vue"
export default component.exports